// «Zobacz w środku»: ONLY real pages from RELIGIA GOTOWA™ Tom 1 (Gamma Estudio), exported from the final PDF (23/10/2026).
// Source: religia-gotowa/media/PAGINAS.md. Texts describe exactly what each page shows. Tom 1 has no sprawdzian (they are in Tom 6).
const CDN = 'https://d2ol7oe51mr4n9.cloudfront.net/user_37MCUZnyYhEzEhcHxirwYMezT12';
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [{
  src: `${CDN}/b66bb2b1-04e0-411d-8817-0a5f4c0dad7d.webp`,
  label: 'Tom 1 · Okładka',
  title: 'Plan roczny 2026/2027 i 12 lekcji minuta po minucie',
  text: 'Pierwszy z sześciu tomów: klasy 1–8, lekcje po 45 minut, PDF do druku.'
}, {
  src: `${CDN}/589edf1e-0bd0-4758-a652-60d77a6740aa.webp`,
  label: 'Tom 1 · s. 5',
  title: 'Plan roczny – klasa 1',
  text: 'Od września do czerwca: tematy lekcji na każdy miesiąc i święta – od Aniołów Stróżów po Boże Ciało. Taki plan masz dla każdej klasy od 1 do 8.'
}, {
  src: `${CDN}/9774ea80-4450-4396-a070-02bdc277f295.webp`,
  label: 'Tom 1 · s. 21',
  title: 'Lekcja 4 · Adwent – czekamy na Pana Jezusa',
  text: 'Strona katechety dla klasy 2: cel, pomoce, przebieg minuta po minucie (0–45), słowa katechety i notatka do zeszytu. Z datami Adwentu 2026.'
}, {
  src: `${CDN}/4cf386ea-5fc7-434c-a180-a5dcb1b59f06.webp`,
  label: 'Tom 1 · s. 22',
  title: 'Karta pracy – Czekamy na Pana Jezusa',
  text: 'Ta sama lekcja na 3 poziomach: A – wsparcie, B – podstawa, C – wyzwanie. Na dole klucz dla katechety.'
}, {
  src: `${CDN}/c3a9cf0a-bf9d-47fa-83d3-1efc375d42bb.webp`,
  label: 'Tom 1 · s. 14',
  title: '3 poziomy na jednej lekcji',
  text: 'Dla kogo jest każdy poziom i jakie zadania zawiera. Cała klasa pracuje nad tym samym tematem – oceniamy wiedzę i pracę, nigdy wiarę ucznia.'
}];
